import { ref } from 'vue'

export const useGoogleMapHelpers = (gmap = null) => {
  const map = ref(gmap);

  const setMap = (gmap) => map.value = gmap;

  const lineDistance = (point1, point2) => {
    if (!point1) return undefined
    if (!point2) return undefined

    let xs = point2.lng() - point1.lng();

    if (xs > 180) xs = 360 - xs;

    xs = Math.pow(xs, 2);

    const ys = Math.pow(point2.lat() - point1.lat(), 2);

    return Math.sqrt(xs + ys)
  }

  const getPointFromLatLon = (latLon, gmap) => {
    map.value = gmap || map.value;

    if (!map.value) return;

    var scale = Math.pow(2, map.value.getZoom())
    var proj = map.value.getProjection()
    var bounds = map.value.getBounds()

    var nw = proj.fromLatLngToPoint(
      new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getSouthWest().lng())
    )
    var point = proj.fromLatLngToPoint(latLon)

    return {
      x: Math.floor((point.x - nw.x) * scale),
      y: Math.floor((point.y - nw.y) * scale)
    }
  }

  const getPointsFromLatLons = (latLons, gmap) => {
    map.value = gmap || map.value;

    if (!map.value) return

    return latLons.map((latLon) => map.value.getPointFromLatLon(latLon, map.value))
  }

  const getLatLonFromPoint = ({ x, y }, gmap) => {
    map.value = gmap || map.value;

    if (!map.value) return;

    const scale = Math.pow(2, map.value.getZoom())
    const proj = map.value.getProjection()
    const bounds = map.value.getBounds()

    const nw = proj.fromLatLngToPoint(
      new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getSouthWest().lng())
    )
    const point = new google.maps.Point()

    point.x = x / scale + nw.x
    point.y = y / scale + nw.y

    return proj.fromPointToLatLng(point)
  }

  const getLatLonsFromPoints = (points, gmap) => {
    map.value = gmap || map.value

    if (!map.value) return

    return points.map((point) => getLatLonFromPoint(point, map.value))
  }  

  const getLatLonAtDistance = ({latLon, distance, heading = 0}) => {
    return google.maps.geometry.spherical.computeOffset(latLon, distance, heading)
  }

  const getDistanceBetweenLatLons = (latLon1, latLon2) => {
    return google.maps.geometry.spherical.computeDistanceBetween(latLon1, latLon2)
  }

  const getDistanceBetweenPoints = (point1, point2) => {
    const deltaX = Math.abs(point2.x - point1.x)
    const deltaY = Math.abs(point2.y - point1.y)
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY)
    return distance
  }  

  const getHeadingBetweenLatLons = (latLon1, latLon2) => {
    return google.maps.geometry.spherical.computeHeading(latLon1, latLon2)
  }  

  return {
    lineDistance,
    getPointFromLatLon,
    getPointsFromLatLons,
    getLatLonFromPoint,
    getLatLonsFromPoints,
    getLatLonAtDistance,
    getDistanceBetweenLatLons,
    getDistanceBetweenPoints,
    getHeadingBetweenLatLons,
    setMap
  }
}
